module.exports = __webpack_public_path__ + "img/1561204657.ebc24c47.jpg";